import { Label, Slider, Checkbox } from '@creanizer/ui'
import type { SocietyInput } from '@creanizer/types'

interface GenerationOptionsFormProps {
  input: SocietyInput
  onChange: (input: SocietyInput) => void
  useStreaming: boolean
  onStreamingChange: (value: boolean) => void
}

export function GenerationOptionsForm({
  input,
  onChange,
  useStreaming,
  onStreamingChange
}: GenerationOptionsFormProps) {
  const handleChange = (field: keyof SocietyInput, value: any) => {
    onChange({ ...input, [field]: value })
  }

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="creativityLevel">
          創造性レベル: {input.creativityLevel || 7}
        </Label>
        <Slider
          id="creativityLevel"
          min={1}
          max={10}
          step={1}
          value={[input.creativityLevel || 7]}
          onValueChange={(value) => handleChange('creativityLevel', value[0])}
        />
        <p className="text-xs text-muted-foreground">
          高いほど独創的で予想外の設定が生成されます
        </p>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="useStreaming"
          checked={useStreaming}
          onCheckedChange={(checked) => onStreamingChange(checked as boolean)}
        />
        <Label htmlFor="useStreaming" className="font-normal cursor-pointer">
          ストリーミングモード
          <span className="text-xs text-muted-foreground ml-2">
            生成中のテキストをリアルタイムで表示します
          </span>
        </Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="useProMode"
          checked={input.useProMode}
          onCheckedChange={(checked) => handleChange('useProMode', checked as boolean)}
        />
        <Label htmlFor="useProMode" className="font-normal cursor-pointer">
          Proモード
          <span className="text-xs text-muted-foreground ml-2">
            より詳細で複雑な設定を生成します（生成時間が長くなります）
          </span>
        </Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="useGemini3Mode"
          checked={input.useGemini3Mode}
          onCheckedChange={(checked) => handleChange('useGemini3Mode', checked as boolean)}
        />
        <Label htmlFor="useGemini3Mode" className="font-normal cursor-pointer">
          Gemini 3 Pro モード
          <span className="text-xs text-muted-foreground ml-2">
            最新の高品質モデルを使用します
          </span>
        </Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="useGemini3FlashMode"
          checked={input.useGemini3FlashMode}
          onCheckedChange={(checked) => handleChange('useGemini3FlashMode', checked as boolean)}
        />
        <Label htmlFor="useGemini3FlashMode" className="font-normal cursor-pointer">
          Gemini 3 Flash モード（試験版）
        </Label>
      </div>
    </div>
  )
}